var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.263 2H4.89502C3.85302 2 3 2.85302 3 3.89502V17.158H4.89502V3.89502H16.263V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68311 7.68408V20.9471H19.1041V7.68408H8.68311ZM8.68311 5.78906H19.1041C19.6071 5.78906 20.0891 5.98906 20.4441 6.34406C20.7991 6.69906 20.9991 7.18108 20.9991 7.68408V20.9471C20.9991 21.4491 20.7991 21.931 20.4441 22.287C20.0891 22.642 19.6071 22.8411 19.1041 22.8411H8.68311C8.18111 22.8411 7.69908 22.642 7.34308 22.287C6.98808 21.931 6.78906 21.4491 6.78906 20.9471V7.68408C6.78906 7.18108 6.98808 6.69906 7.34308 6.34406C7.69908 5.98906 8.18111 5.78906 8.68311 5.78906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconWhite);
export default __webpack_public_path__ + "static/media/copy-icon-white.647654679c9535005284c0829daf1f51.svg";
export { ForwardRef as ReactComponent };